export default {
  title: 'Vastaanota automaattiset kuukausittaiset mainoslehtiset',
  status: {
    enabled: 'Käytössä',
    disabled: 'Pois käytöstä',
  },
  opt_out: {
    on_hint:
      'FoodAmigos-tilaukseesi sisältyy 500 ilmaista mainoslehteä kuukaudessa. Poista käytöstä, jos et halua saada niitä.',
    off_hint: 'Automaattiset mainoslehtiset on keskeytetty. Ota käyttöön jatkaaksesi seuraavasta kuukaudesta.',
    confirm_off: {
      title: 'Poistetaanko automaattiset mainoslehtiset käytöstä?',
      body: 'Jos poistat tämän käytöstä, {{location}} ei saa automaattisia mainoslehtiä seuraavasta kuukaudesta alkaen. Olemassa olevat tilaukset eivät muutu.',
      confirm: 'Poista käytöstä',
      cancel: 'Pidä käytössä',
    },
  },
  approved_design: {
    label: 'Hyväksytty malli kuukausittaisille mainoslehdille',
    auto_option: 'Automaattinen (viimeksi tilattu)',
    flyer_slot: 'Mainoslehti {{slot}}',
    custom: 'Mukautettu',
    untitled: 'Nimetön',
    invalid_warning:
      'Tallennettu malli ei ole enää saatavilla. Viimeksi tilattua mainoslehteä käytetään, kunnes valitset uuden.',
  },
  toasts: {
    failed_to_load: 'Automaattisten mainoslehtien asetusten lataaminen epäonnistui',
    failed_to_save: 'Muutosten tallentaminen epäonnistui',
    saved: 'Muutokset tallennettu',
  },
};
